const VocabFooter = {
  copyright: ['MedCleir © 2025 - Contigo de la mano', '© 2025 - By your side'],

  companny_title: ['Compañía', 'Company'],
  about: ['Nosotros', 'About Us'],
  news: ['Noticias', 'News'],
  staff: ['Personal', 'Staff'],
  jobs: ['Empleos', 'Jobs'],
  contact: ['Contacto', 'Contact'],

  patients: ['Pacientes', 'Patients'],
  professionals: ['Profesionales', 'Professionals'],

  philosophy: ['Filosofía', 'Philosophy'],
  faq: ['Preguntas frecuentes (FAQ)', 'FAQ'],
  privacy: ['Privacidad', 'Privacy'],
  help: ['Ayuda', 'Help'],

  address: [
    'Av. Chingona #1, CDMX, México',
    'Av. Chingona #1, CDMX, México',
  ],
};

export default VocabFooter;
